import toast from "react-hot-toast";

const PRICEME_REDDIT_URL = "https://www.reddit.com/r/PriceMe/";

/**
 * Copies puzzle share text for Reddit (title + indented emoji grid) and opens r/PriceMe.
 */
export async function triggerRedditShare(shareTextTitle: string, shareTextBody: string): Promise<void> {
    const title = shareTextTitle.trim() || "PriceMe";
    if (!shareTextBody.trim()) {
        toast.error("Missing data needed to share this puzzle.");
        return;
    }
    const indentedBody = shareTextBody
        .split("\n")
        .map((row) => `    ${row}`)
        .join("\n");
    const redditText = `${title}\n\n${indentedBody}`.trimEnd();
    try {
        await navigator.clipboard.writeText(redditText);
        toast.success("Copied to clipboard");
    } catch {
        toast.error("There was an error when copying Reddit share text");
        return;
    }
    window.open(PRICEME_REDDIT_URL, "_blank", "noopener,noreferrer");
}
